import { render } from "./VCheckbox.vue?vue&type=template&id=b4970abe&ts=true"
import script from "./VCheckbox.vue?vue&type=script&lang=ts"
export * from "./VCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__